import { useEffect, useRef, useState } from 'react'
import { Outlet, useLocation } from 'react-router-dom'

import { useAuth } from '@/hooks/useAuth'
import Sidebar from './Sidebar'
import Header from './Header'

export default function Layout() {
  const [isMobileOpen, setIsMobileOpen] = useState(false)
  const mainRef = useRef<HTMLElement>(null)
  const { pathname } = useLocation()
  useAuth() // Ensure auth context is available

  useEffect(() => {
    mainRef.current?.scrollTo(0, 0)
  }, [pathname])

  return (
    <>
      {/* Mobile overlay */}
      {isMobileOpen && (
        <div
          className="fixed inset-0 bg-black/80 z-10 md:hidden"
          onClick={() => setIsMobileOpen(false)}
        />
      )}

      <div className="flex h-screen overflow-hidden">
        {/* Sidebar - dark themed, matches CD layout */}
        <Sidebar isMobileOpen={isMobileOpen} onMobileClose={() => setIsMobileOpen(false)} />

        {/* Main content area */}
        <div className="flex-1 flex flex-col overflow-hidden">
          {/* Header - matches CD pattern */}
          <Header onMobileMenuToggle={() => setIsMobileOpen(true)} />

          {/* Page content.
              scrollbar-gutter:stable permanently reserves the vertical
              scrollbar's width so toggling it (e.g. filtering a list down to
              fewer rows) doesn't change the content width and shift every
              %/fr-based layout -- the "columns/filters jump when filtering"
              bug (OR-363). */}
          <main ref={mainRef} className="flex-1 overflow-auto bg-white p-8 relative [scrollbar-gutter:stable]">
            <Outlet />
          </main>
        </div>
      </div>

    </>
  )
}
